<div id="{{Id}}-Selected" 
  [ngClass]="columnInfoDto.IsReadOnly || dataItem.IsDelete? 'not-allowed can-be-selected' : 'can-be-selected max-h'">
  <span class="splitscreen">
      <span id="{{Id}}-Name" 
        [ngClass]="dataItem.IsDelete? 'left pd-disabled' : 'left'" 
        (click)="clickName()">
        {{formatTimeFrame}}
      </span>
      <span id="{{Id}}-Icon" class="right">
        <mat-icon 
        [ngClass]="columnInfoDto.IsReadOnly || dataItem.IsDelete? 'not-allowed' : ''"
        class="pd-float-right mat-icon emds-find-control-icon clickable material-icons mat-ligature-font mat-icon-no-color" (click)="clickIcon()">
        alarm</mat-icon>
      </span>
  </span>
</div>
